import Skeleton from "react-loading-skeleton";
import { useTranslation } from "react-i18next";

import classes from "./styles.module.scss";

import type { IAppointmentStatusProps } from "@components/molecules/appointmentStatus";
import { AppointmentStatus } from "@components/molecules/appointmentStatus";
import { Typography } from "@components/atoms/typography";
import { addColon } from "@utils";

/**
 * AppointmentStatusPlace component displays the appointment status within the appointment card.
 * @param isLoading
 * @param props
 * @param {IAppointmentStatus} props.status - The status of the appointment.
 * @returns AppointmentStatusPlace The rendered AppointmentStatusPlace component.
 */
export function AppointmentStatusPlace({
  isLoading,
  ...props
}: IAppointmentStatusProps) {
  const { t } = useTranslation("common");

  return (
    <div className={classes.appointmentStatus}>
      <Typography fontFamily={"dana"}>{addColon(t("visitStatus"))}</Typography>
      {!isLoading && <AppointmentStatus {...props} />}
      {isLoading && <Skeleton width={"7rem"} height={"1.5rem"} />}
    </div>
  );
}
